// extracted by mini-css-extract-plugin
export default {"wrapper":"home_wrapper__HJelK","skills":"home_skills__ebZHF","hi":"home_hi__ml8c1","hiTitle":"home_hiTitle__Qn-Kz","hiElement":"home_hiElement__mirji"};